import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/sa/game-sa/build-engage.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Build Engaging Games with Our Mobile Game Development Company
            </h2>
            <p>
              Are you looking to create a mobile game that keeps players hooked?
              As a leading mobile game development company, we are experts in
              creating exceptional gaming experiences that will be based on the
              comprehension of your idea, considering the preferences of your
              audience. We transform ideas into engaging games that captivate
              players and drive success with our customized approach.
            </p>
            <p>
              At TekRevol, we understand that every mobile game is unique and
              that’s why we take a personalized approach to development. From
              concept to launch, our team works closely with you to bring your
              vision to life. Our professional developers ensure every aspect of
              the game is crafted as per your requirements. With our expertise
              in game design or game development, we offer high-quality games
              that entertain, engage, and leave a lasting impression.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
